import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import SEO from "../components/seo/SEO";
import Breadcrumbs from "../components/seo/Breadcrumbs";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", topic: "general", message: "" });
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Please fill in all fields."); return; }
    setStatus("loading");
    try {
      await axios.post(`${API}/contact`, form);
      setStatus("done");
      toast.success("Thanks! We'll get back to you soon.");
      setForm({ name: "", email: "", topic: "general", message: "" });
    } catch { setStatus("idle"); toast.error("Something went wrong. Please try again."); }
  };

  const field = "w-full rounded-lg border border-border bg-white px-4 py-2.5 text-sm outline-none transition-colors focus:border-brand focus:ring-2 focus:ring-brand/30";

  return (
    <>
      <SEO title="Contact — MyFinancesGuru Tools" description="Get in touch with the MyFinancesGuru Tools team with questions, feedback or product support." path="/contact" />
      <div className="mx-auto max-w-2xl px-4 py-12 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Contact", to: "/contact" }]} />
        <h1 className="font-heading text-4xl font-bold tracking-tight text-foreground sm:text-5xl">Contact us</h1>
        <p className="mt-4 text-lg text-muted-foreground">Questions, feedback or product support — we'd love to hear from you.</p>

        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="contact-form">
          <div className="grid gap-4 sm:grid-cols-2">
            <input data-testid="contact-name" placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={field} />
            <input data-testid="contact-email" type="email" placeholder="you@email.com" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={field} />
          </div>
          <select data-testid="contact-topic" value={form.topic} onChange={(e) => setForm({ ...form, topic: e.target.value })} className={field}>
            <option value="general">General question</option>
            <option value="product">Product support</option>
            <option value="feedback">Feedback / suggestion</option>
            <option value="bug">Report an issue</option>
          </select>
          <textarea data-testid="contact-message" rows={6} placeholder="How can we help?" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={field} />
          <button type="submit" data-testid="contact-submit" disabled={status === "loading"} className="inline-flex items-center gap-2 rounded-full bg-action px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-action-hover disabled:opacity-60">
            {status === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Send message
          </button>
        </form>
      </div>
    </>
  );
}
